import { client } from '../lib/client';

// 고객 배송조회(공개) — 대시보드에서 만든 24시간 링크의 토큰으로 읽는다. 로그인 없음.
// 200 { serial_number, order } · 404 { code: 'LINK_INVALID' }(없음·만료·닫힘 전부 같은 답)
export const trackLinkAPI = (token) => (
  client({
    url: `/v1/track/${encodeURIComponent(token)}`,
    method: 'get',
    loading: false,
  })
);
